import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import TweenOne from 'rc-tween-one';
import { DownOutlined } from '@ant-design/icons';
import { Statistic, Image, Tooltip } from "antd";
import ConnectWallet from "./ConnectWallet.jsx";
import CollectionMintButton from "./CollectionMintButton.jsx";
import { MAX_MINTABLE_NFT } from "../constants";
import { Row, Col } from 'antd';

function typeFunc(a) {
    if (a.key === 'line') {
      return 'right';
    } else if (a.key === 'button') {
      return 'bottom';
    }
    return 'left';
  }
  
// DEBUG FLAG - set to false in prod
const DEBUG = false;

const { Countdown } = Statistic;

// COLLECTION LAUNCH DATE
// UNCOMMENT FOR PROD
// IMPORTANT - IN JS months starts at 0, ie January is 0, March is 2!!
const MINT_START = new Date(Date.UTC(2022, 4, 23, 18, 0, 0, 0)); //18H UTC 1PM CST
const MINT_PUBLIC_START = new Date(Date.UTC(2022, 4, 24, 20, 0, 0, 0)); //18H UTC 1PM CST

// TEST CODE
// const MINT_START = new Date(Date.UTC(2022, 2, 18, 15, 35, 30, 0)); //18H UTC 1PM CST
// const MINT_PUBLIC_START = new Date(Date.UTC(2022, 2, 18, 15, 57, 0, 0)); //18H UTC 1PM CST

const calculateTimeLeft = () => {
  let difference = MINT_PUBLIC_START - +new Date();

  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      in: "The public sale will open ",
      day: Math.floor(difference / (1000 * 60 * 60 * 24)),
      h: Math.floor((difference / (1000 * 60 * 60)) % 24),
      min: Math.floor((difference / 1000 / 60) % 60),
      s: Math.floor((difference / 1000) % 60)
    };
  }

  return timeLeft;
}

const refreshOnFinish = () => {
  setTimeout(() => {
    window.location.reload();
  }, 1);
};

export default function CollectionBanner({ 
  onEnterChange,
  gasPrice,
  signer,
  provider,
  address,
  blockExplorer,
  totalSupply,
  price,
  balance,
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
  whiteListEnabled,
  contract,
  freeMintOpened,
  publicSaleEnabled,
  }) {

  // LAUNCH
  // UNCOMMENT FOR PROD
  const [isCountdownFinished, setIsCountdownFinished] = useState(new Date() >= MINT_START);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const mintRemaining = totalSupply ? (MAX_MINTABLE_NFT - totalSupply.toNumber()) > 0 : false;
  
  // UNCOMMENT FOR DEVELOPMENT
  //const [isCountdownFinished, setIsCountdownFinished] = useState(true);
  //const mintRemaining = true;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsCountdownFinished(new Date() >= MINT_START);
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });  

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <span key="{interval}">
        {timeLeft[interval]} {interval}{" "}
      </span>
    );
  });

  if (DEBUG) provider && console.log("provider", provider.connection.url);
  if (DEBUG) provider && console.log("provider", provider);
  if (DEBUG) signer && console.log("signer", signer);
  if (DEBUG) signer && console.log("signer address", signer.getAddress());
  
  if (DEBUG) console.log("address", address);
  
  const countdown = (
    <Countdown title="COUNTDOWN TO MINT" value={MINT_START} format="D d HH:mm:ss"/>
  );

  const countdownPublicSale = (
    <p>
    {timerComponents}
    </p>
  );

  // Message displayed when minted out - replace href with the URL of the collection in a marketplace
  const outOfNFTs = (
    <p className="mint-outofnft">
        {/* Sold out! Find us on <a href="empty" target="_blank">Paintswap</a>. */}
        Sold out!
    </p>
  );

  return (
    <section className="banner-wrapper-collection">
      <div className="collection-container">
      {/* <Row>
        <Col md={4} sm={0}>
        <Image src="img/column_left.png" preview={false}/>
        </Col>
        <Col md={16} sm={24}> */}
          <p className="mint-outofnft">
            500 Moon Masters NFTs
          </p>
          <p className="mint-outofnft">
            1 per Tx - Max 3 per wallet
          </p>
          {isCountdownFinished && web3Modal && mintRemaining && 
            <ConnectWallet
              address={address}
              web3Modal={web3Modal}
              loadWeb3Modal={loadWeb3Modal}
              logoutOfWeb3Modal={logoutOfWeb3Modal}
            />  
          } 
          <p className="mint-outofnft"></p>
          <Image className="banner-wrapper-img" src="assets/Moonmasters.gif" preview={false}/>
          {!isCountdownFinished && countdown}
          {!mintRemaining && outOfNFTs}
          {isCountdownFinished && web3Modal && web3Modal.cachedProvider && mintRemaining && 
            <CollectionMintButton
              contract={contract}
              signer={signer}
              provider={provider}
              address={address}
              blockExplorer={blockExplorer}
              totalSupply={totalSupply}
              price={price}
              balance={balance}
              whiteListEnabled={whiteListEnabled}
              publicSaleEnabled={publicSaleEnabled}
              freeMintOpened={freeMintOpened}
            />
          }
        {/* </Col>
        <Col md={4} sm={0}>
        <Image src="img/column_right.png" preview={false}/>
        </Col>
      </Row>  */}
      </div>
    </section>
  );
}
CollectionBanner.propTypes = {
  onEnterChange: PropTypes.func,
};
